module.exports = __webpack_public_path__ + "static/media/DSC01482.9b216e0b.jpg";